import { emitOpenedEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking, featureIndex) => {
    const { labels } = cinemaTracking;
    return {
        ...cinemaTracking,
        position: parseInt(featureIndex, 10),
        status: "expanded",
        labels,
    };
};

const buildRecommendations = (recommendationsTracking) => {
    return recommendationsTracking.map((tracking) => ({
        ...tracking,
        status: "loaded",
    }));
};

export default (cinemaTracking, recommendationsTracking, featureIndex, variationId) => {
    const event = {
        name: "open",
        features: [buildCinema(cinemaTracking, featureIndex), ...buildRecommendations(recommendationsTracking)],
    };

    const openedAdditionalLabels = {
        product_VariationId: [variationId],
    };
    emitOpenedEvent(event, openedAdditionalLabels);
};
